import { useNewEmail } from "../../../frontend/globalStates/NewEmail";
import { Typography } from "@mui/material";

export default function SendVerificationEmail() {
  const { newEmail } = useNewEmail();

  return (
    <Typography>
      Um email de verificação foi enviado para: <span style={{ fontWeight: "bold" }}>{newEmail}</span>.
      <br/>Após verificar, faça login com seu novo email.
      <br/><br/>Seu email só será alterado após a verificação.
    </Typography>
  )
}